export const NAME = 'pupils'
export const LABEL = 'Uczestnicy'
export const PATH = `/${NAME}/`
export const PATH_PL = `/uczestnicy/`
